import { HTMLRenderer } from 'common/html-renderer.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { HighSeasWarnings } from 'common/warning/warning-high-seas.js';
import { useContext } from 'react';
import { IModule } from 'redux-state/layout/types.js';
import { ILocationWarningType } from 'redux-state/weather-warnings/types.js';
import { DATE_TIME_FORMAT_STANDARD, formatDate } from 'utilities/date.js';
import { WarningSeverityContext } from 'utilities/weather-warnings/context/context-warning-severity.js';

interface IForecast {
  header?: string;
  text?: string[];
}

interface IHighSeasForecast {
  forecasts: IForecast[];
  warning?: ILocationWarningType;
  issuedAt?: string;
  area?: string;
  disclaimer?: string;
}

export const HighSeasForecast = ({ config, isDrawer, modulePath }: IModule<IHighSeasForecast>) => {
  const { setWarningSeverity } = useContext(WarningSeverityContext);
  const { forecasts, issuedAt, area, disclaimer, warning } = config;

  return (
    <Tile dataModule="high-seas-forecast" config={config}>
      <div className="Tile-body">
        <TileBodyHeaderV2 isDrawer={isDrawer} modulePath={modulePath} config={config} />

        {area && <p className="u-textGrey u-mT-sm u-mB-0">Area from {area}</p>}

        {issuedAt && (
          <p className="u-textGrey u-mT-sm u-mB-0">
            <span className="u-textBold">Issued: </span>
            {formatDate(issuedAt, DATE_TIME_FORMAT_STANDARD)}
          </p>
        )}

        {warning && <HighSeasWarnings location={warning} setWarningSeverity={setWarningSeverity} />}

        {forecasts.map((forecast, index) => (
          <Forecast key={index} forecast={forecast} />
        ))}

        {disclaimer && <p className="fineprint u-textGrey u-mT-0 u-mB-0">{disclaimer}</p>}
      </div>
    </Tile>
  );
};

function Forecast(props: { forecast: IForecast }) {
  const {
    forecast: { header, text },
  } = props;

  return (
    <>
      {header && <h2>{header}</h2>}
      {text?.map((content, index) => <HTMLRenderer key={index} content={content} />)}
    </>
  );
}
